import type { FooterFragment, MainNavigationFragment } from '~/types/craft-schema';

export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        mainNavigation: null as null | MainNavigationFragment,
        footer: null as null | FooterFragment
    }),

    actions: {
        setMainNavigation(payload: MainNavigationFragment) {
            this.mainNavigation = payload;
        },

        setFooter(payload: FooterFragment) {
            this.footer = payload;
        }
    }
});
